import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const PopupModal = ({ show, children, close, disableAutoHide }) => {
  const modalRef = useRef(null);

  const checkESC = (event) => {
    if (disableAutoHide) return;
    if (event.which === 27) {
      close();
    }
  };

  const checkClick = (event) => {
    if (disableAutoHide) return;
    if (modalRef.current === event.target && close) {
      close();
    }
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      modalRef.current.focus();
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  return show
    ? ReactDOM.createPortal(
        <div
          className="modal-backdrop"
          ref={modalRef}
          onKeyDown={checkESC}
          onClick={checkClick}
          role="button"
          tabIndex="0"
        >
          {children}
        </div>,
        document.getElementById('portal')
      )
    : null;
};

export default PopupModal;
